<header id="main-header" class="header-transparent" [ngStyle]="this.isScrolled ? getScrolledHeaderStyles() : getHeaderStyles()">
  <div class="header-body border-top-0 box-shadow-none">
    <div class="header-container container">
      <div class="header-row">
        <div class="header-column col">
          <div class="header-row">
            <div class="header-logo">
              <a (click)="navigateToHome(); $event.preventDefault()">
                <img alt="IU Press" width="181" height="60"
                  priority
                  ngSrc="assets/images/logo_en_trans.png" />
                </a>
              </div>
            </div>
          </div>
          <div class="header-column col-auto justify-content-end">
            <div class="header-row">
              <div class="header-nav header-nav-top-custom header-nav-links header-nav-dropdowns-dark header-nav-light-text order-2 order-lg-1">
                <div id="header-main"
                  class="header-nav-main header-nav-main-mobile-dark header-nav-main-square header-nav-main-dropdown-no-borders header-nav-main-effect-2 header-nav-main-sub-effect-1">
                  <nav class="collapse navbar-collapse justify-content-end" id="main-nav-collapse">
                    <ul class="nav nav-pills justify-content-end" id="mainNav">
                      <li class="nav-item">
                        <a class="nav-link nav-link-clickable" (click)="navigateToHome(); $event.preventDefault()">
                          {{ 'HEADER_HOME' | translate }}
                        </a>
                      </li>
                      @if (showHeaderButtons) {
                        <li class="nav-item">
                          <a class="nav-link nav-link-clickable" (click)="navigateToAbout(); $event.preventDefault()">
                            {{ 'HEADER_ABOUT' | translate }}
                          </a>
                        </li>
                      }
                      @if (showHeaderButtons) {
                        <li class="nav-item">
                          <a class="nav-link nav-link-clickable" (click)="navigateToContact(); $event.preventDefault()">
                            {{ 'HEADER_CONTACT' | translate }}
                          </a>
                        </li>
                      }
                    </ul>
                  </nav>
                </div>
                <button class="btn btn-sm header-btn-collapse-nav"
                  type="button"
                  (click)="toggleMobileNav()"
                  data-bs-toggle="collapse"
                  data-bs-target="#main-nav-collapse"
                  aria-controls="main-nav-collapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation">
                  <i class="fas fa-bars"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
